import React from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { FormControl, FormControlLabel, FormLabel, InputAdornment, MenuItem, Radio, RadioGroup, Stack, TextField } from "@mui/material";
import Cookies from 'universal-cookie';
import LoadingButton from "@mui/lab/LoadingButton";
import _default from "../themes/default";
import getOrdine from "../services/getOrdine";
import DatePickerIta from "./DatePickerMUI";
import SettingsTitle from "./SettingsTitle";
import Loading from "react-loading";
import getProdotti from "../services/getProdotti";
import editConsegna from "../services/editConsegna";
import getGiacenze from "../services/getGiacenze";
import createDDT from "../services/createDDT";
import addReminder from "../services/addReminder";
import addDdt from "../services/addDdt";
import getCliente from "../services/getCliente";

const cookies = new Cookies();
var token = cookies.get('token', { path: '/' });
var username = cookies.get('username', { path: '/' });

const groupInput = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 15
}

const style = {
    zIndex: 999,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    maxHeight: 600,
    bgcolor: 'white',
    borderRadius: 2,
    border: '0',
    boxShadow: 24,
    p: 4,
    overflowY: 'scroll',
};



export default class serviceMyModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            prodotti: [],
            vettore: '',
            trasporto: '',
            destinazione: '',
            causale: '',
            annotazioni: '',
            data_ritiro: '',
            link_ddt: '',
            lista_pronta: '',
            lista_carico: '',
            data_pronto: '',
            data_consegna: '',
            old_data_pronto: '',
            old_data_consegna: '',
        }
    }


    async componentDidMount() {
        {
            this.setState({ isLoading: true });
            token = cookies.get('token', { path: '/' });
            username = cookies.get('username', { path: '/' });
            let prodottiList = await getProdotti(username, token)

            let giacenze = await getGiacenze(username, token);
            let ordine = await getOrdine(username, token, this.props.modal.id);


            let prodotti = [];

            prodotti = [...JSON.parse(ordine.prodotti)];

            prodotti = prodotti.map((prodotto, i) => {
                let giacenza = giacenze.find(g => g.id_prodotto === prodotto.id_prodotto);
                return { ...prodotto, giacenza: giacenza ? giacenza.giacenza : 0 }
            })

            this.setState({
                ragioneSociale: ordine.ragione_sociale,
                data_pronto: ordine.data_pronto,
                data_consegna: ordine.data_consegna,
                old_data_pronto: ordine.data_pronto,
                old_data_consegna: ordine.data_consegna,
                prodotti,
                conferma_magazzino: ordine.conferma_magazzino,
                conferma_cliente_data: ordine.conferma_cliente_data,
                crea_ddt: ordine.crea_ddt,
                ddt_pdf: ordine.ddt_pdf,
                lista_pronta: ordine.lista_pronta,
                link_ddt: ordine.link_ddt ? ordine.link_ddt : '',
                causale: ordine.causale == null ? '' : ordine.causale,
                trasporto: ordine.trasporto == null ? '' : ordine.trasporto,
                vettore: ordine.vettore == null ? '' : ordine.vettore,
                data_ritiro: ordine.data_ritiro == null ? '' : ordine.data_ritiro,
                destinazione: ordine.destinazione == null ? '' : ordine.destinazione,
                annotazioni: ordine.annotazioni,
                prodottiList,
                isLoading: false,
                linkPdf: ordine.link_pdf,
                lista_carico: ordine.lista_carico,
            })
        }
    }

    async save() {

        let today = new Date();
        let data_pronto = new Date(this.state.data_pronto.split('/')[2], this.state.data_pronto.split('/')[1] - 1, this.state.data_pronto.split('/')[0]);
        let data_consegna = new Date(this.state.data_consegna.split('/')[2], this.state.data_consegna.split('/')[1] - 1, this.state.data_consegna.split('/')[0]);

        today.setHours(0, 0, 0, 0);

        if (data_pronto < today || data_consegna < today) {
            return alert('Le date devono essere maggiore o uguale di oggi');
        }

        if (data_consegna < data_pronto) {
            return alert('La data di consegna deve essere maggiore o uguale alla data di pronto');
        }

        editConsegna(username, token, this.state.data_pronto, this.state.data_consegna, this.props.modal.id).then((res) => {
            if (res.result === 'ok') {
                this.props.onReload();
                this.props.onClose();
            }
        })
        let ordine = await getOrdine(username, token, this.props.modal.id);

        if (this.state.old_data_pronto !== this.state.data_pronto || this.state.old_data_consegna !== this.state.data_consegna) {
            addReminder(username, token, 'Date pronto e consegna modificate ' + ordine.rif, 'service', 'ordine', ordine.id)
        } else {
            addReminder(username, token, 'Conferma magazzino ' + ordine.rif, 'service', 'ordine', ordine.id)
        }
    }

    DDT() {
        let ddt = {
            causale: this.state.causale,
            destinazione: this.state.destinazione,
            trasporto: this.state.trasporto,
            vettore: this.state.vettore,
            annotazioni: this.state.annotazioni,
            data_ritiro: this.state.data_ritiro,
            id: this.props.modal.id,
        }

        if (!ddt.causale) return alert('Inserire causale');
        if (!ddt.destinazione) return alert('Inserire destinazione');
        if (!ddt.trasporto) return alert('Inserire trasporto');
        if (!ddt.vettore) return alert('Inserire vettore');
        if (!ddt.data_ritiro) return alert('Inserire data ritiro');

        createDDT(username, token, ddt).then(async (res) => {
            if (res.result === 'ok') {
                let ordine = await getOrdine(username, token, this.props.modal.id);
                let cliente = await getCliente(username, token, ordine.id_cliente);
                addDdt(username, token, {
                    cliente: this.state.ragioneSociale,
                    rif: ordine.rif,
                    destinazione: ddt.destinazione,
                    citta: cliente.citta,
                    indirizzo: cliente.indirizzo,
                    causale: ddt.causale,
                    trasporto: ddt.trasporto,
                    vettore: ddt.vettore,
                    annotazioni: ddt.annotazioni,
                    data_ritiro: ddt.data_ritiro,
                    p_iva: cliente.p_iva,
                    prodotti: JSON.stringify(this.state.prodotti),
                    ordine: ordine.id,
                });
                window.open(res.link, '_blank');
                this.props.onReload();
                this.props.onClose();
            }
        })
        getOrdine(username, token, this.props.modal.id).then((ordine) => {
            addReminder(username, token, 'DTT creato ' + ordine.rif, 'service', 'ordine', ordine.id)
        })
    }

    close() {
        this.props.onClose();
    }

    render() {
        if (this.state.isLoading) return <Loading />;
        return (
            <Modal
                open={this.props.modal.show}
                onClose={() => this.close()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack direction={"column"} spacing={2} sx={{ flex: 1 }}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {this.props.title}
                        </Typography>
                        <Stack direction={'row'} spacing={2} sx={{ flex: 1 }} >
                            <TextField fullWidth inputProps={{ readOnly: true}} value={this.state.ragioneSociale} label="Ragione Sociale" variant="outlined" onChange={(e) => this.setState({ ragioneSociale: e.target.value })} InputLabelProps={{ shrink: this.state.ragioneSociale }} />
                        </Stack>

                        <Stack direction='row' spacing={4} sx={{ flex: 1, mb: 3, }}>
                            <DatePickerIta
                                readOnly={this.state.conferma_magazzino === '1'}
                                grow
                                label="Data pronto"
                                startValue={this.state.data_pronto}
                                onValueChange={(date) => {
                                    this.setState({ data_pronto: date });
                                }}
                            />
                            <DatePickerIta
                                readOnly={this.state.conferma_magazzino === '1'}
                                grow
                                label="Data consegna"
                                startValue={this.state.data_consegna}
                                onValueChange={(date) => {
                                    this.setState({ data_consegna: date });
                                }}
                            />
                        </Stack>

                        {/* PRODOTTI */}
                        <Stack spacing={3} sx={{ flex: 1 }}>
                            <SettingsTitle title="Prodotti" />
                            {/* SELECT PRODOTTI */}
                            <div>
                                {
                                    this.state.prodotti.length > 0 && (

                                        this.state.prodotti.map((el, i) => {

                                            return (
                                                <div key={i} style={groupInput}>
                                                    <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} >
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            label="Prodotto"
                                                            value={el.id_prodotto}
                                                            InputProps={{ readOnly: true }}
                                                            onChange={(e) => {
                                                                let arr = [...this.state.prodotti]
                                                                arr[i].label = e.target.value;
                                                                arr[i].prezzo = this.state.prodottiList.find((n) => n.id === e.target.value).prezzo;
                                                                arr[i].id_prodotto = this.state.prodottiList.find((n) => n.id === e.target.value).id;
                                                                arr[i].quantita = 1;
                                                                this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                                            }}
                                                        >
                                                            {
                                                                this.state.prodottiList.map((prodotto, i) => {
                                                                    return (
                                                                        <MenuItem key={i + prodotto.nome} value={prodotto.id}>{prodotto.nome}</MenuItem>
                                                                    )
                                                                })
                                                            }
                                                        </TextField>

                                                        {/* QUANTITA */}
                                                        <TextField
                                                            type="number"
                                                            variant="outlined"
                                                            label={'Quantita'} value={el.quantita}
                                                            InputLbelProps={{ shrink: el.quantita }}
                                                            InputProps={{ readOnly: true }}
                                                            onChange={(e) => {
                                                                let arr = this.state.prodotti
                                                                arr[i].quantita = e.target.value
                                                                this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                                            }}
                                                        />
                                                        {/* PREZZO UNITARIO */}
                                                        {(this.state.crea_ddt !== '1') &&
                                                            <TextField
                                                                error={parseInt(el.giacenza) < parseInt(el.quantita)}
                                                                type="number"
                                                                variant="outlined"
                                                                label={'Giacenza magazzino'}
                                                                value={el.giacenza}
                                                                InputProps={{ readOnly: true }}
                                                            />}

                                                    </Stack>
                                                </div>
                                            )
                                        })
                                    )

                                }
                            </div>
                        </Stack>

                        {
                            (this.state.crea_ddt === '1' && this.state.conferma_cliente_data !== null) && (
                                <>
                                    <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                                        <TextField fullWidth value={this.state.causale} label="Causale Trasporto" variant="outlined" onChange={(e) => this.setState({ causale: e.target.value })} InputLabelProps={{ shrink: this.state.causale }} error={this.state.causale.trim().length === 0} />
                                    </Stack>

                                    <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                                        <TextField fullWidth value={this.state.destinazione} label="Luogo destinazione" variant="outlined" onChange={(e) => this.setState({ destinazione: e.target.value })} InputLabelProps={{ shrink: this.state.destinazione }}
                                            error={this.state.destinazione.trim().length === 0} />
                                    </Stack>

                                    <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                                        <FormControl>
                                            <FormLabel id="demo-row-radio-buttons-group-label">Trasporto a mezzo:</FormLabel>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                onChange={(e) => this.setState({ trasporto: e.target.value })}
                                                value={this.state.trasporto}
                                            >
                                                <FormControlLabel value="mittente" control={<Radio />} label="Mittente" />
                                                <FormControlLabel value="vettore" control={<Radio />} label="Vettore" />
                                                <FormControlLabel value="destinatario" control={<Radio />} label="Destinatario" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Stack>

                                    <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                                        <TextField fullWidth value={this.state.vettore} label="Vettore" variant="outlined" onChange={(e) => this.setState({ vettore: e.target.value })} InputLabelProps={{ shrink: this.state.vettore }}
                                            error={this.state.vettore.trim().length === 0} />
                                    </Stack>

                                    <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                                        <DatePickerIta
                                            redBorder={this.state.data_ritiro.trim().length === 0}
                                            grow
                                            label="Data ritiro"
                                            startValue={this.state.data_ritiro}
                                            onValueChange={(date) => {
                                                this.setState({ data_ritiro: date });
                                            }}
                                        />
                                    </Stack>

                                    <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                                        <TextField multiline rows={4} fullWidth value={this.state.annotazioni} label="Annotazioni" variant="outlined" onChange={(e) => this.setState({ annotazioni: e.target.value })} InputLabelProps={{ shrink: this.state.annotazioni }} />
                                    </Stack>
                                </>
                            )
                        }

                        <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                            {
                                this.state.conferma_magazzino !== '1' &&
                                <LoadingButton fullWidth sx={{ flex: 1, minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => this.save()}>
                                    Conferma date
                                </LoadingButton>
                            }
                            {
                                this.state.lista_pronta === '1' && <LoadingButton fullWidth sx={{ flex: 1, minHeight: 50 }} style={{ backgroundColor: _default.palette.secondary.main }} variant='contained' loading={this.state.isLoading} onClick={() => window.open(this.state.lista_carico, '_blank')}>
                                    Visualizza Lista di Carico
                                </LoadingButton>
                            }

                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        )
    }
}